import { MutationTree } from 'vuex';
import { AttendeeState } from './types';
import attendee, { Value } from '@/shared/model/attendee';

export const mutations: MutationTree<AttendeeState> = {
  setAttendees(state, payload: Value) {
    state.attendees.items = payload.value.map(attendee.parse);
    state.attendees.total = payload['@odata.count'] || 0;
    state.attendees.isLoading = false;
  },
  setAttendeesTotal(state, payload: number) {
    state.attendees.total = payload;
  },
  setAttendeesIsLoading(state, payload: boolean) {
    state.attendees.isLoading = payload;
  },

  setInterested(state, payload: Value) {
    state.interested.items = payload.value.map(attendee.parse);
    state.interested.total = payload['@odata.count'] || 0;
    state.interested.isLoading = false;
  },

  setInterestedTotal(state, payload: number) {
    state.interested.total = payload;
  },
  setInterestedIsLoading(state, payload: boolean) {
    state.interested.isLoading = payload;
  },

  resetAttendeesPaging(state) {
    state.attendees.searchParams.dataOption.page = 1;
    state.attendees.searchParams.dataOption.itemsPerPage = 10;
    state.attendees.searchParams.dataOption.filter = '';
    state.attendees.searchParams.filter = '';
  },
  resetInterestedPaging(state) {
    state.interested.searchParams.dataOption.page = 1;
    state.interested.searchParams.dataOption.itemsPerPage = 10;
    state.interested.searchParams.dataOption.filter = '';
    state.interested.searchParams.filter = '';
  },
  resetApplicationUsersPaging(state) {
    state.applicationUsers.searchParams.dataOption.page = 1;
    state.applicationUsers.searchParams.dataOption.itemsPerPage = 10;
    state.applicationUsers.searchParams.dataOption.filter = '';
    state.applicationUsers.searchParams.filter = '';
  },

  setApplicationUsers(state, payload: Value) {
    state.applicationUsers.items = payload.value.map(attendee.parse);
    state.applicationUsers.total = payload['@odata.count'] || 0;
    state.applicationUsers.isLoading = false;
  },

  setAttendeesWithoutMembershipTotalOpenCount(state, payload: Value) {
    state.attendeesWithoutMembershipTotalOpenCount =
      payload['@odata.count'] ?? 0;
  },

  setAttendeesActiveInactiveTotalOpenCount(state, payload: Value) {
    state.attendeesActiveInactiveTotalOpenCount = payload['@odata.count'] ?? 0;
  },
};
